import React from 'react';
import { connect } from 'react-redux';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import DatasetWizardActionsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../../components/DatasetWizardActionsContainer';

const DatasetSettingsActions = ({
  category,
  code,
  compact,
  finishDataset,
  goBack,
}) => (
  <DatasetWizardActionsContainer>
    <BackButton onClick={goBack} iconOnly={compact} />
    <CloseButton onClick={() => finishDataset(category, code)} messageId="actions.finish" />
  </DatasetWizardActionsContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(DatasetSettingsActions);
